const InviteList = () => {
    return (
        <h1>Invite List</h1>
    )
}

export default InviteList